module.exports = __webpack_public_path__ + "img/2.fb8133fc.png";